<template>
  <span class="flag-icon" :title="countryName">
    <CountryFlag :country="props.country" size="small"></CountryFlag>
  </span>
  {{ countryName }}
</template>

<script setup lang="ts">
import CountryFlag from "vue-country-flag-next";
import countries from "i18n-iso-countries";
import { computed } from "@vue/reactivity";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  country: string;
}>();

const { locale } = useI18n();
const countryName = computed(() =>
  countries.getName(props.country, locale.value)
);
</script>

<style lang="scss" scoped>
.flag-icon {
  width: 1.3rem;
  height: 1rem;
  vertical-align: top;
  display: inline-block;
  margin-right: 0.2rem;
}
</style>
